import { 
    FETCH_SEARCH_RIDES_RENTAL, 
    FETCH_SEARCH_RIDES_RENTAL_SUCCESS, 
    FETCH_SEARCH_RIDES_RENTAL_FAILED,
    CONFIRM_BOOKING_RENTAL,
    CONFIRM_BOOKING_RENTAL_SUCCESS,
    CONFIRM_BOOKING_RENTAL_FAILED,
    FETCH_BOOKED_RENTALS,
    FETCH_BOOKED_RENTALS_SUCCESS,
    FETCH_BOOKED_RENTALS_FAILED
    
} from "../store/types";

const initialState = {
    availableRides: [],
    loading: false,
    error: {
        flag: false,
        msg: null
    }
};

export const rentalReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SEARCH_RIDES_RENTAL:
            return { ...state, loading: true, error: { flag: false, msg: null } };
        case FETCH_SEARCH_RIDES_RENTAL_SUCCESS:
            return { ...state, loading: false, availableRides: action.payload };
        case FETCH_SEARCH_RIDES_RENTAL_FAILED:
            return { ...state, loading: false, error: { flag: true, msg: action.payload } };
        case FETCH_SEARCH_RIDES_RENTAL:
            return { ...state, loading: true };
        case FETCH_SEARCH_RIDES_RENTAL_SUCCESS:
            return { ...state, loading: false, availableRides: action.payload };
        case FETCH_SEARCH_RIDES_RENTAL_FAILED:
            return { ...state, loading: false, error: { flag: true, msg: action.payload } };
        case FETCH_BOOKED_RENTALS:
            return { ...state, loading: true };
        case FETCH_BOOKED_RENTALS_SUCCESS:
            return { ...state, loading: false, bookedRentals: action.payload };
        case FETCH_BOOKED_RENTALS_FAILED:
            return { ...state, loading: false, bookedRentals: [], error: { flag: true, msg: action.payload } };
        case CONFIRM_BOOKING_RENTAL:
            return { ...state, loading: true };
        case CONFIRM_BOOKING_RENTAL_SUCCESS:
            return { ...state, loading: false };
        case CONFIRM_BOOKING_RENTAL_FAILED:
            return { ...state, loading: false };
        default:
            return state;
    }
};